module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/android-icon-36x36-a58484cbb1e94095e92c4d26a6545612.png";